import { number, arrayOf, string } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import dynamic from 'next/dynamic';
import { connectStateResults } from 'react-instantsearch-dom';
import Teaser from 'components/Teaser';
import RecipeStar from 'components/RecipeStar';
import { HAS_RECIPE_BOX } from 'constants/site';
import { getPostIdFromUrl } from 'util/link';
import printCleanCookTime from 'util/recipes';
import styles from './styles';

const SaveToRecipeBoxActions = dynamic(
  () => import('components/SaveToRecipeBoxActions'),
  {
    ssr: false
  }
);

const RATED_COLOR = '#ff881f';

function TeaserCard(props) {
  const {
    rating,
    ratingCount,
    prepTimeMin,
    prepTimeMax,
    cookTimeMin,
    cookTimeMax,
    allSearchResults,
    recipeId,
    url,
    sourceSets,
    placeholders
  } = props;

  const selectedFacets = allSearchResults.hierarchicalFacets
    .map(facet => {
      const result = [];
      if (facet.data) {
        facet.data.forEach(item => {
          if (item.isRefined) result.push({ [facet.name]: item.name });
        });
      }
      return result;
    })
    .filter(facetArray => facetArray.length > 0);

  const gtmAttrs = allSearchResults
    ? {
        'data-gtm-search-query': allSearchResults.query,
        'data-gtm-search-facets': JSON.stringify(selectedFacets),
        'data-gtm-search-url': props.url
      }
    : null;

  const recipeTime = printCleanCookTime(
    prepTimeMin,
    prepTimeMax,
    cookTimeMin,
    cookTimeMax
  );

  const teaserProps = {
    ...props,
    variant: 'searchResult',
    fallbackDims: {
      height: 200,
      width: 300
    },
    sourceSets,
    gtmAttrs,
    dek: recipeTime,
    placeholders
  };

  return (
    <div className="TeaserCard">
      <style jsx>{styles}</style>
      <Teaser {...teaserProps} tags={undefined} />
      <div className="TeaserCard__info">
        {allSearchResults && allSearchResults.index.includes('gen-recipes') && (
          <div className="TeaserCard__rating">
            <ul className="TeaserCard__ratingStars">
              {new Array(5).fill(null).map((_, i) => {
                const pos = i + 1;
                return (
                  <li key={pos} className="TeaserCard__ratingStar">
                    <RecipeStar
                      rating={rating}
                      pos={pos}
                      fillColor={RATED_COLOR}
                    />
                  </li>
                );
              })}
            </ul>
            <span className="TeaserCard__ratingTotal">({ratingCount})</span>
          </div>
        )}
        {HAS_RECIPE_BOX && recipeId !== undefined && (
          <SaveToRecipeBoxActions
            recipeId={recipeId}
            postId={getPostIdFromUrl(url)}
            postUrl={url}
            placement="search"
            gtmAttrs={{ placement: 'Recipe Search Result' }}
          />
        )}
      </div>
    </div>
  );
}

TeaserCard.propTypes = {
  ...Teaser.propTypes,
  index: string,
  cookTimeMax: number,
  cookTimeMin: number,
  prepTimeMax: number,
  tags: arrayOf(string),
  prepTimeMin: number,
  rating: number,
  flips: arrayOf(string),
  ratingCount: number
};

TeaserCard.defaultProps = {
  ...Teaser.defaultProps,
  cookTimeMax: null,
  cookTimeMin: null,
  prepTimeMax: null,
  prepTimeMin: null,
  rating: null,
  tags: [],
  flips: [],
  ratingCount: 0
};

const mapStateToProps = state => {
  const { app } = state;
  return {
    flips: app.flips
  };
};

export default connect(mapStateToProps)(connectStateResults(TeaserCard));
